import React, { useCallback, useState } from "react";
import { cn } from "../../utils/cn";

import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import i18n from "../../i18n";
import CustomTooltip from "../tooltip";

interface DateTimePickerInputProps {
  label: string;
  required?: boolean;
  value?: string;
  labelStyle?: string;
  onChange: (...event: any[]) => void;
  minDate?: Date;
  maxDate?: Date;
  error?: string;
  errorStyle?: string;
  readOnly?: boolean;
  isInfoToolTip?: boolean;
  infoToolTip?: React.ReactNode;
  isTimeOnly?: boolean;
}

const customStyles =
  "flex py-3 px-4 w-full rounded-[15px] cursor-pointer border-2 border-gray-soft bg-transparent text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-soft outline-none focus:border-gray-soft focus:ring-0 disabled:cursor-not-allowed ";

const DateTimePickerInput = ({
  label,
  labelStyle,
  value,
  required = false,
  onChange,
  minDate,
  maxDate,
  error,
  errorStyle,
  readOnly = false,
  isInfoToolTip = false,
  infoToolTip,
  isTimeOnly = false,
}: DateTimePickerInputProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenCalendar = useCallback(() => {
    setTimeout(() => setIsOpen(true), 10);
  }, []);

  return (
    <div className="relative flex flex-col gap-[3px]">
      <div className="relative flex items-center gap-2">
        {label && (
          <>
            <label className={cn("text-[13px] font-normal", labelStyle)}>
              {label} {required && <span className="text-red-500">*</span>}
            </label>

            {isInfoToolTip && <CustomTooltip>{infoToolTip}</CustomTooltip>}
          </>
        )}
      </div>

      <div className={cn(customStyles)}>
        <DateTimePicker
          value={value}
          clearIcon={null}
          disableCalendar={isTimeOnly}
          onChange={onChange}
          minDate={minDate}
          maxDate={maxDate}
          disabled={readOnly}
          calendarIcon={null}
          isCalendarOpen={isOpen}
          onCalendarOpen={handleOpenCalendar}
          format={
            isTimeOnly
              ? "hh:mm a"
              : i18n.language === "en"
              ? "dd/MM/yyyy, hh:mm a"
              : "dd/MM/yyyy ،hh:mm a"
          }
        />
      </div>

      {!!error && (
        <p
          className={cn(
            "text-red-600 text-[10px] mt-[1px] absolute -bottom-[15px] italic",
            errorStyle,
            i18n.language === "en" ? "left-[2px]" : "right-[2px]"
          )}
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default React.memo(DateTimePickerInput);
